import { render, staticRenderFns } from "./PdvDesktopLayout.vue?vue&type=template&id=100fc6c6&scoped=true"
import script from "./PdvDesktopLayout.vue?vue&type=script&lang=js"
export * from "./PdvDesktopLayout.vue?vue&type=script&lang=js"
import style0 from "./PdvDesktopLayout.vue?vue&type=style&index=0&id=100fc6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100fc6c6",
  null
  
)

export default component.exports